import { getHtmlFromRedactorField } from "@/utils/utils"

const Paragraph = ({ text }) => {
	return <div className="typo-strawford typo-strawford-14" dangerouslySetInnerHTML={getHtmlFromRedactorField(text)} />
}

export default Paragraph
